import type { InitialState } from '@schibsted-nmp/advertising-shared';

export type Script = Readonly<
  {
    name: string;
    src: Script.Url;
  } & Partial<Pick<HTMLScriptElement, 'defer' | 'crossOrigin'>>
>;

export namespace Script {
  export type Url = `https://${string}.js`;

  export function* getServerHtml(
    initialState: InitialState,
    getScripts: (initialState: InitialState) => Iterable<Script, void, void>,
    serverHtml?: string
  ) {
    if (serverHtml) yield serverHtml;

    const scripts = getScripts(initialState);

    for (const { name, src, defer, crossOrigin } of scripts) {
      yield `<script async="async" id="advt-script-${name}" src="${src}"${
        defer ? ' defer="defer"' : ''
      }${crossOrigin ? ` crossorigin="${crossOrigin}"` : ''}></script>`;
    }
  }
}
